module.exports = __webpack_public_path__ + "img/Deco_table_mariage.a4c0147.png";